import { Injectable } from '@angular/core';
import { ROUTES } from '../constants';
import { IPeriodiciteResponse } from '../models/periodicite.model';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PeriodiciteService {
  constructor(
    private httpClient: HttpClient
  ) {}

  /**
   * Get all periodicities
   * @returns Observable<IPeriodiciteResponse>
   */
  gets(): Observable<IPeriodiciteResponse> {
    return this.httpClient.get<IPeriodiciteResponse>(`${ROUTES.periodicite.list}`);
  }

  /**
   * Get one periodicite
   * @returns Observable<IPeriodiciteResponse>
   */
  get(id: number): Observable<IPeriodiciteResponse> {
    return this.httpClient.get<IPeriodiciteResponse>(`${ROUTES.periodicite.one}/${id}`);
  }

  /**
   * Get periodicite by service
   * @returns Observable<IPeriodiciteResponse>
   */
  getByService(service: number): Observable<IPeriodiciteResponse> {
    return this.httpClient.get<IPeriodiciteResponse>(`${ROUTES.periodicite.useServiceID}/${service}/2`);
  }
}
